import { Question } from '../../types';
import { imageCache } from 'utils/imageCache';
import { extractImageKey, resolveSignedImageUrl } from 'utils/signedImageUrl';

export const preloadImageUrl = (url: string) =>
  new Promise<void>((resolve) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => resolve();
    img.src = url;
  });

export const getPrimaryQuestionImageUrl = (question: Question | null | undefined): string | null => {
  if (!question) {
    return null;
  }

  if (question.media?.media_type === 'image') {
    if (question.media?.url) {
      return question.media.url;
    }
    if (question.media?.storage_key) {
      return question.media.storage_key;
    }
  }

  if (question.visual_component_url && question.visual_component_url.trim()) {
    return question.visual_component_url;
  }

  if (question.image_url && question.image_url.trim()) {
    return question.image_url;
  }

  return null;
};

export const isPrimaryQuestionImageReady = (question: Question | null | undefined): boolean => {
  const imageUrl = getPrimaryQuestionImageUrl(question);
  if (!imageUrl) {
    return true;
  }

  const key = extractImageKey(imageUrl);
  if (!key) {
    return true;
  }

  return Boolean(imageCache.get(key));
};

export const preloadPrimaryQuestionImage = async (
  question: Question | null | undefined,
): Promise<boolean> => {
  const imageUrl = getPrimaryQuestionImageUrl(question);
  if (!imageUrl) {
    return true;
  }

  const key = extractImageKey(imageUrl);
  if (key && imageCache.get(key)) {
    return true;
  }

  try {
    const resolvedUrl = await resolveSignedImageUrl(imageUrl);
    await preloadImageUrl(resolvedUrl);
    return true;
  } catch {
    return true;
  }
};
